import formReducer from '@frontend/design_system/src/redux/forms/forms.reducer'
import { activityHistoryReducer } from './activityHistory/slice'
import { filtersReducer } from './filters/slice'
import { notificationReducer } from './notifications/slice'
import { locationsReducer } from './locations/slice'
import { fleetReducer } from './fleet/slice'
import { profileReducer } from './profile/slice'
import { authReducer } from './login/slice'
import { registrationReducer } from './registration/slice'
import { commonReducer } from './common/slice'
import { combineReducers, configureStore, Reducer } from '@reduxjs/toolkit'
import { applicationsReducer } from './applications/slice'
import { sortingReducer } from './sorting/slice'
import { dashboardReducer } from './dashboard/slice'
import { dropoffReducer } from './dropoff/slice'
import { termsReducer } from './terms/slice'
import { joinReducer } from './join/slice'
import { FormChildren } from 'types/form'
import { bookingHistoryReducer } from './bookingHistory/slice'

type FormState = {
  [key: string]: FormChildren
}

const rootReducer = combineReducers({
  registrationReducer,
  authReducer,
  profileReducer,
  fleetReducer,
  locationsReducer,
  notificationReducer,
  filtersReducer,
  activityHistoryReducer,
  commonReducer,
  applicationsReducer,
  sortingReducer,
  dashboardReducer,
  dropoffReducer,
  forms: formReducer as Reducer<FormState>,
  termsReducer,
  joinReducer,
  bookingHistoryReducer,
})

export const setupStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
  })

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = ReturnType<typeof setupStore>['dispatch']

export const store = setupStore()
